module.exports = function ($state) {
    return {
        restrict: 'E',
        template: require('./selfexclusion-error.html').trim(),
        link(scope) {
            scope.redirectBack = function () {
                if (scope.redirectTo) {
                    $state.go(scope.redirectTo);
                }
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/selfexclusion-error-directive.js
 **/